module.exports = __webpack_public_path__ + "static/img/banner10.34513cce.png";